module.exports = __webpack_public_path__ + "static/media/red-onion.c8f9aa23.jpg";